import Vue from 'vue'
import Router from 'vue-router'
import HomePage from './views/HomePage.vue'
import ProductsPage from './views/ProductsPage.vue'
import ProductDetailPage from './views/ProductDetailPage.vue'
import ProductListPage from './views/ProductListPage.vue'
import ProductItemPage from './views/ProductItemPage.vue'
import CustomizePage from './views/CustomizePage.vue'
import StrengthPage from './views/StrengthPage.vue'
import KnowledgePage from './views/KnowledgePage.vue'
import NewsDetailPage from './views/NewsDetailPage.vue'
import ContactPage from './views/ContactPage.vue'
import ColoursPage from './views/ColoursPage.vue'
import ColourDetailPage from './views/ColourDetailPage.vue'
import QualityPage from './views/QualityPage.vue'
import CarePage from './views/CarePage.vue'
import CasesPage from './views/CasesPage.vue'
import PrivacyPolicyPage from './views/PrivacyPolicyPage.vue'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    { path: '/', name: 'home', component: HomePage },
    { path: '/products', name: 'products', component: ProductsPage },
    { path: '/products.html', redirect: '/products' },
    { path: '/products_list/Plank.html', redirect: '/products-list/plank' },
    { path: '/products_list/Herringbone Plank 90deg.html', redirect: '/products-list/herringbone-plank-90deg' },
    { path: '/products_list/Chevron Plank 45deg.html', redirect: '/products-list/chevron-plank-45deg' },
    { path: '/products_list/Parquet.html', redirect: '/products-list/parquet' },
    { path: '/products_list/Oversized Plank.html', redirect: '/products-list/oversized-plank' },
    { path: '/products_list/Light Wood Floors.html', redirect: '/products-list/light-wood-floors' },
    { path: '/products_list/Dark Wood Floors.html', redirect: '/products-list/dark-wood-floors' },
    { path: '/products-list/:slug', name: 'product-list', component: ProductListPage },
    { path: '/products_page/AM-01.html', redirect: '/products-page/am-01' },
    { path: '/products_page/AM-02.html', redirect: '/products-page/am-02' },
    { path: '/products_page/AM-03.html', redirect: '/products-page/am-03' },
    { path: '/products_page/AM-04.html', redirect: '/products-page/am-04' },
    { path: '/products_page/AM-05.html', redirect: '/products-page/am-05' },
    { path: '/products_page/AM-06.html', redirect: '/products-page/am-06' },
    { path: '/products_page/AM-07.html', redirect: '/products-page/am-07' },
    { path: '/products_page/AM-08.html', redirect: '/products-page/am-08' },
    { path: '/products_page/AM-09.html', redirect: '/products-page/am-09' },
    { path: '/products_page/AM-10.html', redirect: '/products-page/am-10' },
    { path: '/products_page/AM-11.html', redirect: '/products-page/am-11' },
    { path: '/products_page/AM-12.html', redirect: '/products-page/am-12' },
    { path: '/products_page/AM-13.html', redirect: '/products-page/am-13' },
    { path: '/products-page/:slug', name: 'product-item', component: ProductItemPage },
    { path: '/products_page/Plank.html', redirect: '/products-list/plank' },
    { path: '/products_page/Herringbone Plank 90deg.html', redirect: '/products-list/herringbone-plank-90deg' },
    { path: '/products_page/Chevron Plank 45deg.html', redirect: '/products-list/chevron-plank-45deg' },
    { path: '/products_page/Parquet.html', redirect: '/products-list/parquet' },
    { path: '/products_page/Oversized Plank.html', redirect: '/products-list/oversized-plank' },
    { path: '/products/:slug', name: 'product-detail', component: ProductDetailPage },
    { path: '/customize', name: 'customize', component: CustomizePage },
    { path: '/customize.html', redirect: '/customize' },
    { path: '/strength', name: 'strength', component: StrengthPage },
    { path: '/advantage.html', redirect: '/strength' },
    { path: '/knowledge', name: 'knowledge', component: KnowledgePage },
    {
      path: '/news.html',
      redirect: to => ({ path: '/knowledge', query: to.query })
    },
    { path: '/news/:slug', name: 'news-detail', component: NewsDetailPage },
    { path: '/contact', name: 'contact', component: ContactPage },
    {
      path: '/contact.html',
      redirect: to => {
        const q = to.query
        const tabMap = { 1: 'factory', 2: 'partner', 3: 'quote' }
        const key = Object.keys(q).find(k => tabMap[k])
        if (key) {
          return { path: '/contact', query: { tab: tabMap[key] } }
        }
        return { path: '/contact', query: q }
      }
    },
    { path: '/colours', name: 'colours', component: ColoursPage },
    { path: '/colours.html', redirect: '/colours' },
    { path: '/colour_page/Light Wood Floors.html', redirect: '/products-list/light-wood-floors' },
    { path: '/colour_page/Dark Wood Floors.html', redirect: '/products-list/dark-wood-floors' },
    { path: '/colours/:slug', name: 'colour-detail', component: ColourDetailPage },
    { path: '/quality', name: 'quality', component: QualityPage },
    { path: '/quality.html', redirect: '/quality' },
    { path: '/care', name: 'care', component: CarePage },
    { path: '/care.html', redirect: '/care' },
    { path: '/cases', name: 'cases', component: CasesPage },
    { path: '/case', redirect: '/cases' },
    { path: '/case.html', redirect: '/cases' },
    { path: '/case_page/Germany case.html', redirect: '/cases' },
    { path: '/case_page/China case.html', redirect: '/cases' },
    { path: '/case_page/Korea case.html', redirect: '/cases' },
    { path: '/case_page/USA case.html', redirect: '/cases' },
    { path: '/case_page/Japan case.html', redirect: '/cases' },
    { path: '/cases/:slug', redirect: '/cases' },
    { path: '/privacy-policy', name: 'privacy-policy', component: PrivacyPolicyPage },
    { path: '/privacy-policy.html', redirect: '/privacy-policy' },
    { path: '*', redirect: '/' }
  ]
})
